<template>
  <footer class="border-bdr-subtle flex items-center border-t py-1.5">
    <slot>
      <div class="flex items-center gap-2 px-3">
        <slot name="text">
          <p v-if="steps" class="text-body-small text-fgr-secondary">
            {{ currentStep }} {{ $t("of").toLowerCase() }} {{ steps }}
          </p>
          <p class="text-body-small">{{ text }}</p>
        </slot>
      </div>
      <div class="ms-auto flex items-center gap-1.5 px-1.5">
        <slot name="actions">
          <Button type="button" :variant="ButtonVariant.Tertiary" @click="() => emits('cancel')">{{
            $t("cancel")
          }}</Button>
          <Button
            type="button"
            :variant="destructive ? ButtonVariant.Destructive : ButtonVariant.Primary"
            :disabled="disabled"
            :loading="loading"
            @click="() => emits('confirm')"
            >{{ confirmText || $t("confirm") }}</Button
          >
        </slot>
      </div>
    </slot>
  </footer>
</template>

<script lang="ts" setup>
  const {
    confirmText = "",
    currentStep = 0,
    destructive = false,
    disabled = false,
    loading = false,
    steps = 0,
    text = "",
  } = defineProps<{
    confirmText?: string;
    currentStep?: number;
    destructive?: boolean;
    disabled?: boolean;
    loading?: boolean;
    steps?: number;
    text?: string;
  }>();
  const emits = defineEmits<{
    (e: "cancel" | "confirm"): void;
  }>();
</script>
